console.log("sizesAvailable.js");

setInterval(function () {
  var filters = document.getElementsByClassName("t4s-filter__values");

  for (var i = 0; i < filters.length; i++) {
    var filter = filters[i];

    var links = filter.getElementsByTagName("a");

    for (var j = 0; j < links.length; j++) {
      var link = links[j];

      var href = link.getAttribute("href");
      if (href.includes("filter.v.option") && !href.includes("availability")) {
        link.href = href.replace(
          "filter.v.option",
          "filter.v.availability=1&filter.v.option"
        );
      }
    }
  }
}, 500);